import { theme } from '../../../../styles/theme';

export const NoTestsContainer = {
  alignItems: 'center'
};

export const NoTestsStackImage = {
  marginTop: {
    tablet: '50px',
    mobile: '20px'
  },
  width: '168px',
  marginBottom: '20px'
};

export const NoTestsDescription = {
  fontSize: '14px',
  paddingBottom: '30px',
  fontWeight: '600',
  color: theme.palette.common.darkBlue2,
  [theme.breakpoints.down('tablet')]: {
    width: '248px',
    paddingBottom: 0
  }
};
